module.exports = {
  DEFAULT_LOCALE: 'en',
  blogLocales: ['de', 'fr'],
  locales: ['de', 'en', 'es', 'fr', 'it', 'nl'],
};
